import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

type requestWidgetTypes = 'platformRequests' | 'contactRequests' | 'orderRequest' | 'priceRequests';

@Component({
  selector: 'markant-platform-requests-widget',
  templateUrl: 'requests-widget.component.html',
  styleUrls: ['requests-widget.component.scss'],
})
export class BaseRequestsWidgetComponent implements OnChanges {
  @Input() loading = true;
  @Input() widgetType!: requestWidgetTypes;
  @Input() openRequestsCount = 0;
  @Input() inProgressRequestsCount = 0;
  @Input() primaryChipText = '';
  @Input() secondaryChipText = '';

  singularity = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['openRequestsCount']) {
      this.singularity = this.openRequestsCount > 1 ? '' : 'Singular';
    }
  }
}
